exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attempt-list[data-v-bcb5fbe8] {\n  -moz-column-count: 3;\n       column-count: 3;\n  -moz-column-gap: 0;\n       column-gap: 0;\n  list-style: none;\n}\n.attempt-list > li[data-v-bcb5fbe8] {\n  border-left: solid 1px #8f8f8f;\n}\nh4[data-v-bcb5fbe8] {\n  border-left: solid 1px #8f8f8f;\n}", ""]);

// exports
